import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from "recompose";

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import TextField from '@material-ui/core/TextField';
import AddIcon from '@material-ui/icons/Add';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import SyncIcon from '@material-ui/icons/Sync';

import { history } from '../../_helpers';
import CardHeader from "../../modules/Card/CardHeader.jsx";
import './TableStyle.css';
import CreateCsvFile from './CreateCsvFile';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
    }
    ,
    button: {
        margin: theme.spacing.unit,
    },
    searchField: {
        width: '100px'
    }
});

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const rows = [
    // { id: 'id', numeric: false, disablePadding: false, label: 'Project ID' },
    { id: 'ProjectName', numeric: false, disablePadding: false, label: 'Project Name' },
    { id: 'Tag', numeric: false, disablePadding: false, label: 'Tag' },
    // { id: 'DepartmentName', numeric: false, disablePadding: false, label: 'Project Team' },
    { id: 'ProjectCreateTime', numeric: false, disablePadding: false, label: 'Project Create Time' },
    { id: 'CompletedPercent', numeric: false, disablePadding: false, label: 'Percent Completed' },
    { id: 'ManDayAchievingRate', numeric: false, disablePadding: false, label: 'Man-Day Achieving Rate' },
];

class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy } = this.props;
        // onSelectAllClick, numSelected, rowCount

        return (
            <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                        {/* 
                            <Checkbox
                                indeterminate={numSelected > 0 && numSelected < rowCount}
                                checked={numSelected === rowCount}
                                onChange={onSelectAllClick}
                            /> 
                        */}
                    </TableCell>

                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? 'none' : 'default'}
                                sortDirection={orderBy === row.id ? order : false}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
});

let EnhancedTableToolbar = props => {
    const { numSelected, classes, handleDeleteClick, handleSearchChange, handleOpen, data, showArchivedDataChange, handleShowArchivedDataChange } = props; //handleImportPipedriveOpen

    return (
        <Toolbar
            className={classNames(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <div className={classes.title}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subtitle1">
                        {numSelected} selected
                    </Typography>
                ) : (
                        <CardHeader color="success">
                            <div style={{ height: '5vh' }}>Projects</div>
                        </CardHeader>
                    )}
            </div>
            <Tooltip title="Create Project">
                <IconButton aria-label="Create Project">
                    <AddIcon onClick={handleOpen} />
                </IconButton>
            </Tooltip>

            <div style={{ width: '80%' }}>
                <FormControlLabel
                    control={
                        <Switch
                            checked={showArchivedDataChange}
                            onChange={handleShowArchivedDataChange}
                        />
                    }
                    label="Show Archived"
                />
            </div>

            {/* <Tooltip title="Import Pipedrive Deals">
                <IconButton aria-label="Import Pipedrive Deals">
                    <SyncIcon onClick={handleImportPipedriveOpen} />
                </IconButton>
            </Tooltip> */}
            <div className={classes.spacer} />
            <div className={classes.actions}>
                {numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon onClick={handleDeleteClick} />
                        </IconButton>
                    </Tooltip>
                ) : null
                }
            </div>

            <CreateCsvFile data={data} />

            <TextField
                label="Search"
                style={{ width: '80vh' }}
                margin="normal"
                placeholder="Search"
                variant="outlined"
                onChange={handleSearchChange()}
            />
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

class EnhancedTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: 'desc',
            orderBy: 'id',
            selected: [],
            data: [],
            page: 0,
            rowsPerPage: 10,
            searchStr: '',
            showArchivedDataChange: false
        };
        this.handleDeleteClick = this.handleDeleteClick.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.handleShowArchivedDataChange = this.handleShowArchivedDataChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            data: convert(nextProps.projects.items),
            selected: []
        });
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    handleSelectAllClick = event => {
        if (event.target.checked) {
            this.setState(state => ({ selected: state.data.map(n => n.id) }));
            return;
        }
        this.setState({ selected: [] });
    };

    handleDeleteClick() {
        this.props.handleDeleteTable(this.state.selected)
    }

    handleSearchChange = name => event => {
        this.setState({
            searchStr: event.target.value
        })
    };

    handleClick = (event, n) => {
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(n.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, n.id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        if (event === 'check') {
            this.setState({ selected: newSelected });
        }
        else if (event === 'edit') {
            this.props.handleEditTable(n);
        }
        else if (event === 'detail') {
            history.push('/Project/' + n.id);
        }

    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;

    handleOpen = () => {
        this.props.handleOpen()
    };

    handleImportPipedriveOpen = () => {
        this.props.handleImportPipedriveOpen()
    };

    handleShowArchivedDataChange() {
        this.setState({
            showArchivedDataChange: !this.state.showArchivedDataChange
        });
    };

    render() {
        const { classes } = this.props;
        const { order, orderBy, selected, rowsPerPage, page } = this.state;
        const data = findSearchStr(this.state.data, this.state.searchStr, this.state.showArchivedDataChange)
        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

        return (
            <Paper className={classes.root}>
                <EnhancedTableToolbar
                    numSelected={selected.length}
                    handleDeleteClick={this.handleDeleteClick}
                    handleSearchChange={this.handleSearchChange}
                    handleOpen={this.handleOpen}
                    handleImportPipedriveOpen={this.handleImportPipedriveOpen}
                    data={data}
                    showArchivedDataChange={this.state.showArchivedDataChange}
                    handleShowArchivedDataChange={this.handleShowArchivedDataChange}
                />
                <div className={classes.tableWrapper}>
                    <Table id="ProjectsTable" className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={this.handleSelectAllClick}
                            onRequestSort={this.handleRequestSort}
                            rowCount={data.length}
                        />
                        <TableBody>
                            {
                                stableSort(data, getSorting(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map(n => {
                                        n.id = n.ProjectId;
                                        const isSelected = this.isSelected(n.id);
                                        return (
                                            <TableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isSelected}
                                                tabIndex={-1}
                                                key={n.id}
                                                selected={isSelected}
                                            >
                                                <TableCell padding="checkbox">
                                                    <IconButton color="secondary" aria-label="Edit" className={styles.button} onClick={event => this.handleClick('edit', n)}>
                                                        <EditIcon />
                                                    </IconButton>
                                                    <IconButton color="secondary" aria-label="Edit" className={styles.button} onClick={event => this.handleClick('detail', n)}>
                                                        <SearchIcon />
                                                    </IconButton>
                                                    {
                                                        this.props.user.id === n.CreatedUserId
                                                            ? <Checkbox checked={isSelected} onClick={event => this.handleClick('check', n)} />
                                                            : null
                                                    }
                                                </TableCell>
                                                {/* <TableCell component="th" scope="row">{n.id}</TableCell> */}
                                                <TableCell>{n.id} -  {n.ProjectName ? <span>{n.CompanyName} - <b>{n.ProjectName}</b></span> : <span style={{ color: 'red' }}>Pending</span>}</TableCell>
                                                <TableCell>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexWrap: 'wrap'
                                                    }}>
                                                        {
                                                            n.Tag ? n.Tag.map((item, index) => {
                                                                return (
                                                                    <div key={index}
                                                                        style={{
                                                                            border: '1px solid #ed3b57',
                                                                            width: 'fit-content',
                                                                            borderRadius: '10px',
                                                                            fontSize: '1em',
                                                                            color: '#ed3b57',
                                                                            padding: '0 10px',
                                                                            marginRight: '2px'
                                                                        }}>
                                                                        # {item.value}
                                                                    </div>
                                                                )
                                                            }) : ''
                                                        }
                                                    </div>
                                                </TableCell>
                                                <TableCell>{n.ProjectCreateTime}</TableCell>
                                                <TableCell>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                                        {n.ProgressStatus === '1' ? <abbr title="Pending"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'red', marginRight: '10px' }} /></abbr> : null}
                                                        {n.ProgressStatus === '2' ? <abbr title="In-progress"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'yellow', marginRight: '10px' }} /></abbr> : null}
                                                        {n.ProgressStatus === '3' ? <abbr title="Completed"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'green', marginRight: '10px' }} /></abbr> : null}
                                                        {n.ProgressStatus === '4' ? <abbr title="Cancelled"><div style={{ width: '10px', height: '10px', borderRadius: '99em', backgroundColor: 'grey', marginRight: '10px' }} /></abbr> : null}
                                                        {n.CompletedPerent}
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                                        {n.ManDayAchievingRate}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                            }

                            {emptyRows > 0 && (
                                <TableRow style={{ height: 49 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                <TablePagination
                    component="div"
                    count={data.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        'aria-label': 'Previous Page',
                    }}
                    nextIconButtonProps={{
                        'aria-label': 'Next Page',
                    }}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
            </Paper>
        );
    }
}

function convert(data) {
    let filterData = data ? data : []
    let convertData = filterData.map((value) => {
        return {
            id: value.ProjectId,
            ClientId: value.ClientId,
            CompanyName: value.CompanyName,
            ProjectId: value.ProjectId,
            ProjectName: value.ProjectName,
            SalesId: value.UserId,
            SalesName: value.UserName,
            DepartmentId: value.DepartmentId,
            DepartmentName: value.DepartmentName,
            Tag: value.Tag,
            TagDisplay: value.Tag ? value.Tag.map(item => item.value + ' ') : '',
            DealId: value.PipedriveJSON ? value.PipedriveJSON.id : '',
            DealTitle: value.PipedriveJSON ? value.PipedriveJSON.title : '',
            DealOrgName: value.PipedriveJSON ? value.PipedriveJSON.org_name : '',
            DealOwnerName: value.PipedriveJSON ? value.PipedriveJSON.owner_name : '',
            CreatedUserDepartmentName: value.CreatedUserDepartmentName,
            CreatedUserName: value.CreatedUserName,
            CreatedUserId: value.CreatedUserId,
            CompletedPerent: (value.CompletedPerent !== null ? Number(value.CompletedPerent) : 0) + ' %',
            ManDayAchievingRate: Number(((value.Duration / 8) / value.Manday * 100).toFixed(0)) + ' %',
            ProgressStatus: value.ProgressStatus,
            ProjectCreateTime: value.CreatedTime ? convertDate(value.CreatedTime) : ''
        };
    });

    return convertData;
}

function findSearchStr(data, searchStr, showArchivedDataChange) {
    var filterEmpty = data
        .filter(function (item) {
            if (showArchivedDataChange) {
                if (item.ProgressStatus === '4') {
                    return true
                }
                else {
                    return false
                }
            }
            else {
                if (item.ProgressStatus !== '4') {
                    return true
                }
                else {
                    return false
                }
            }
        }).filter(function (item) {
            if (searchStr === 0 || searchStr === '') {
                return true
            }
            else {
                const ProjectId = item.id ? item.id.toString() : '';
                const ProjectName = item.ProjectName ? item.ProjectName : '';
                const SalesName = item.SalesName ? item.SalesName : '';
                const CompanyName = item.CompanyName ? item.CompanyName : '';
                const DepartmentName = item.DepartmentName ? item.DepartmentName : '';
                const TagName = item.TagDisplay ? item.TagDisplay.toString() : '';

                for (let i = 0; i < ProjectId.length; i++) {
                    if (ProjectId.toUpperCase().substring(i, i + searchStr.length) === searchStr.toUpperCase()) {
                        return true
                    }
                }

                for (let i = 0; i < ProjectName.length; i++) {
                    if (ProjectName.toUpperCase().substring(i, i + searchStr.length) === searchStr.toUpperCase()) {
                        return true
                    }
                }

                for (let i = 0; i < SalesName.length; i++) {
                    if (SalesName.toUpperCase().substring(i, i + searchStr.length) === searchStr.toUpperCase()) {
                        return true
                    }
                }

                for (let i = 0; i < CompanyName.length; i++) {
                    if (CompanyName.toUpperCase().substring(i, i + searchStr.length) === searchStr.toUpperCase()) {
                        return true
                    }
                }

                for (let i = 0; i < DepartmentName.length; i++) {
                    if (DepartmentName.toUpperCase().substring(i, i + searchStr.length) === searchStr.toUpperCase()) {
                        return true
                    }
                }

                for (let i = 0; i < TagName.length; i++) {
                    if (TagName.toUpperCase().substring(i, i + searchStr.length) === searchStr.toUpperCase()) {
                        return true
                    }
                }

                return false
            }
        })

    return filterEmpty
}

function convertDate(dateStr) {
    let date = new Date(dateStr);
    let year = date.getFullYear();
    let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    let day = date.getDate() + 1 < 10 ? '0' + (date.getDate() + 1) : date.getDate() + 1;
    let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    let second = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { projects } = state;

    return {
        user,
        projects
    };
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(EnhancedTable);


// WEBPACK FOOTER //
// ./src/components/Projects/EnhancedTable.js